import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { listParametersQueryOpts } from "./hook";
import { SIGNUP_SERVICE_NAME, SIGNUP_FLOW_PARAM_NAMES } from "./constants";
import { paramSelectFn } from "./lib";
import { ParamContext } from "./ParamContext";

export const useFetchParameters = () => useQuery(listParametersQueryOpts(
  SIGNUP_SERVICE_NAME, SIGNUP_FLOW_PARAM_NAMES, paramSelectFn));

export const useParamContext = () => {
  const params = useContext(ParamContext);
  if (!params) {
    throw new Error('useParams can only be used within a Provider');
  }
  const { BASIC_MEMBERSHIP_PLAN: MONTHLY_MEMBERSHIP_ID, PREMIUM_MEMBERSHIP_PLAN: ANNUAL_MEMBERSHIP_ID, DOCUSEAL_MEMBERSHIP_AGREEMENT_SRC, DOCUSEAL_MEMBERSHIP_APP_SRC, DOCUSEAL_RULES_AND_REGULATION_SRC, STRIPE_ACCESS_KEY } = params;

  return { MONTHLY_MEMBERSHIP_ID, ANNUAL_MEMBERSHIP_ID, DOCUSEAL_MEMBERSHIP_AGREEMENT_SRC, DOCUSEAL_MEMBERSHIP_APP_SRC, DOCUSEAL_RULES_AND_REGULATION_SRC, STRIPE_ACCESS_KEY };
};
